import { ONE_DAY_IN_MS } from '@sohanscript/lib/constants';
import { createIDBPersister } from '@sohanscript/lib/utils/persister';
import type { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import type React from 'react';
import packageJson from '../../../package.json';

export default function ReactQueryPersister({
	children,
	client,
}: {
	children: React.ReactNode;
	client: QueryClient;
}) {
	const persister = createIDBPersister({ key: 'sohanscript' });

	return (
		<PersistQueryClientProvider
			persistOptions={{
				persister,
				maxAge: ONE_DAY_IN_MS,
				buster: `${packageJson.version}`,
			}}
			client={client}
		>
			{children}
		</PersistQueryClientProvider>
	);
}
